import { createApp, setup } from '@/setup'

import EntryWidget from '@/modules/EntryWidget/components/EntryWidget'

const widgets = document.querySelectorAll('.sanitasOvpEntry')
let notificationsEnabled = true

widgets.forEach(element => {
  const props = element.dataset
  if (notificationsEnabled) {
    props.notificationsEnabled = ''
  }
  notificationsEnabled = false

  // Transform props string-booleans to boolean (for TRUE we need an empty string)
  if (props.header === 'true' || props.header === '') {
    props.header = ''
  } else {
    delete props.header
  }
  if (props.tiny === 'true' || props.tiny === '') {
    props.tiny = ''
  } else {
    delete props.tiny
  }

  // Fallback for old AEM implementation
  if (props.whiteBackground === 'true' || props.whiteBackground === '') {
    props.theme = 'light'
  }

  const instance = setup(createApp(EntryWidget, props))
  instance.mount(element)
})
